import { InputField } from "@motleyhand/design"
import type { ComponentProps } from "react"
import FormControl from "./FormControl"
import { maybeNumber } from "@/utils"

export type Props = ComponentProps<typeof InputField> & {
  name: string
}

export default function FormInput({
  name,
  required,
  type = "text",
  onChange: onChangeProp,
  ...rest
}: Props) {
  return (
    <FormControl name={name} required={required}>
      {({ field: { onChange, ...restField }, isError, error }) => (
        <InputField
          id={name}
          required={required}
          type={type}
          aria-invalid={isError}
          error={error}
          onChange={(e) => {
            const { value } = e.target
            onChange(type === "number" ? (maybeNumber(value) ?? null) : value)
            onChangeProp?.(e)
          }}
          {...restField}
          name={name}
          {...rest}
        />
      )}
    </FormControl>
  )
}
